import api from './api';
import { User } from './auth';

export interface CreateUserData {
  email: string;
  firstName?: string;
  lastName?: string;
  role?: 'super_user' | 'site_admin' | 'end_user';
  organisationId?: string | null;
  siteIds?: string[];
  groupIds?: string[];
}

export interface UpdateUserData {
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  role?: 'super_user' | 'site_admin' | 'end_user';
  organisationId?: string | null;
  siteIds?: string[];
  groupIds?: string[];
}

export interface UserSite {
  id: string;
  name: string;
}

export interface UserResponse extends User {
  organisationId?: string | null;
  sites?: UserSite[];
  groups?: { id: string; name: string }[];
  createdAt: string;
  updatedAt: string;
  warning?: string; // Optional warning message (e.g., when user already exists)
}

export const usersApi = {
  getAll: async (): Promise<UserResponse[]> => {
    const { data } = await api.get('/users');
    return data;
  },

  getById: async (id: string): Promise<UserResponse> => {
    const { data } = await api.get(`/users/${id}`);
    return data;
  },

  create: async (user: CreateUserData): Promise<UserResponse> => {
    const { data } = await api.post('/users', user);
    return data;
  },

  update: async (id: string, user: UpdateUserData): Promise<UserResponse> => {
    const { data } = await api.put(`/users/${id}`, user);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },

  forcePasswordReset: async (id: string): Promise<{ message: string }> => {
    const { data } = await api.post(`/users/${id}/force-password-reset`);
    return data;
  },
};
